import React, { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const TableUser = memo(({ data }) => {
  // -------------------------- VAR -----------------------------
  const supporter = data?.supporter;
  const name = supporter?.fullName || supporter?.email;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------

  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!name) return <span>Chưa có hỗ trợ</span>;
  return <span>{name}</span>;
});
export default TableUser;
